import PaymentService from "@/api/service/paymentService";
import { createAsyncFetchThunk } from "@/store/utils";

export const initializePayment = createAsyncFetchThunk(
  "shoppingCart/initializePayment",
  PaymentService.initializePayment,
);
